// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1uFWb","label":"CategoryService_label__2G2Ka","location":"CategoryService_location__4WCUp"};